import focusElement from './focus-element';

/** Moves focus to `ref` if it can be focused */
export default function focusRef(ref) {
  if (ref) {
    focusElement(ref.current);
  }
}
